import {
  Daily,
  Weekly,
  Monthly,
  Refused,
  Discontinued,
  TwentyFourHours,
  OneXAssess,
} from '@mummssoftware/utils/frequencies/frequency-constants';

const Assess = 'Assess';
export const durationList = [
  { id: `1`, label: Daily, value: Daily },
  { id: `2`, label: Weekly, value: Weekly },
  { id: `5`, label: Monthly, value: Monthly },
  { id: `6`, label: Discontinued, value: Discontinued },
  { id: `7`, label: Refused, value: Refused },
  // important value is Assess
  { id: `8`, label: OneXAssess, value: Assess },
  { id: `9`, label: TwentyFourHours, value: TwentyFourHours },
];

export const freqOneOption = { id: `1`, label: '1', value: '1' };
export const freqZeroOption = { id: `0`, label: '0', value: '0' };

export const makeFreqList = (n: number): mumms.OptionType[] | [] => {
  if (n >= 1) {
    const arr: any = [];
    for (let i = 1; i <= n; i++) {
      const option = {
        id: i.toString(),
        label: i.toString(),
        value: i.toString(),
      };
      arr.push(option);
    }
    return arr;
  }
  return [];
};
